<template>
    <div class="reatlas-info-window">
        <div class="reatlas-info-window__content">
            <h3 class="reatlas-info-window__title">{{ title }}</h3>
            <p class="reatlas-info-window__location">{{ location }}</p>
            <p class="reatlas-info-window__details">{{ details }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReatlasMarkerInfoWindow',

    props: {
        title: {
            type: String,
            required: true
        },
        location: {
            type: String,
            required: true
        },
        details: {
            type: String,
            required: true
        }
    }
}
</script>
